import React from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { FDStat } from '@facet-wealth/design';
import HouseholdSectionServiceLayout from './HouseholdSectionServiceLayout';

const HouseholdSectionServiceOverride = buildFacetDesignOverride().nameOverride([
  'serviceLevelCategory',
  'planningVersion',
  'planningMeetingsInCurrentSubscription',
  'currentSubscriptionPeriod',
  'currentEstatePlan',
  'currentTaxFiling',
  'currentEstatePlanStatus',
  'moneyBackGuarantee',
  'userIds',
], {
  _component: () => FDStat,
}, {
  ordinal: 200,
});

function HouseholdSectionService({
  collection,
}) {
  return (
    <MetaFormInline
      resource={collection?.resources()?.head()}
      layout={HouseholdSectionServiceLayout}
      noIndividualSubmitButtons
      padding={'none'}
      metaOverrideSet={HouseholdSectionServiceOverride}
    />
  );
}

HouseholdSectionService.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default HouseholdSectionService;
